// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.pulse-check-survey-dot {
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 5000;
  display: flex;
  align-items: center;
  gap: 4px;
}
.pulse-check-survey-dot__link {
  filter: drop-shadow(0 1px 2px var(--color-background-base));
  font-size: 12px;
  line-height: 16px;
}
.pulse-check-survey-dot__dot {
  position: relative;
  display: block;
  flex: 0 0 14px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
}
.pulse-check-survey-dot__dot::before {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: var(--color-accent-background-base);
  content: "";
  opacity: 0.45;
  animation: pulse-check-survey-dot-pulse 1.8s ease-out infinite;
}
.pulse-check-survey-dot__dot::after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  border: 2px solid var(--color-content-neutral);
  border-radius: 50%;
  background: var(--color-accent-background-base);
  box-shadow: 0 2px 8px var(--color-shadow-base);
  content: "";
  transform: translate(-50%, -50%);
}
@keyframes pulse-check-survey-dot-pulse {
  0% {
    transform: scale(0.75);
    opacity: 0.55;
  }
  70% {
    transform: scale(1.9);
    opacity: 0;
  }
  100% {
    transform: scale(1.9);
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/application/feature/pulse-check-survey/PulseCheckSurveyDot.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAHA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAKF;AAHE;EACE,2DAAA;EACA,eAAA;EACA,iBAAA;AAKJ;AAFE;EACE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAIJ;AAFI;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,+CAAA;EACA,WAAA;EACA,aAAA;EACA,8DAAA;AAIN;AADI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,8CAAA;EACA,kBAAA;EACA,+CAAA;EACA,8CAAA;EACA,WAAA;EACA,gCAAA;AAGN;AAEA;EACE;IACE,sBAAA;IACA,aAAA;EAAF;EAGA;IACE,qBAAA;IACA,UAAA;EADF;EAIA;IACE,qBAAA;IACA,UAAA;EAFF;AACF","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n@pulseCheckSurveyDotSize: 14px;\n@pulseCheckSurveyInnerDotSize: 10px;\n@pulseCheckSurveyLinkHeight: 16px;\n\n.pulse-check-survey-dot {\n  position: fixed;\n  top: @layoutUnit-md;\n  right: @layoutUnit-md;\n  z-index: @zindex--layers-element;\n  display: flex;\n  align-items: center;\n  gap: @layoutUnit-xs;\n\n  &__link {\n    filter: drop-shadow(0 1px 2px var(--color-background-base));\n    font-size: @fontSize-xs;\n    line-height: @pulseCheckSurveyLinkHeight;\n  }\n\n  &__dot {\n    position: relative;\n    display: block;\n    flex: 0 0 @pulseCheckSurveyDotSize;\n    width: @pulseCheckSurveyDotSize;\n    height: @pulseCheckSurveyDotSize;\n    border-radius: 50%;\n\n    &::before {\n      position: absolute;\n      inset: 0;\n      border-radius: 50%;\n      background: var(--color-accent-background-base);\n      content: \"\";\n      opacity: 0.45;\n      animation: pulse-check-survey-dot-pulse 1.8s ease-out infinite;\n    }\n\n    &::after {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: @pulseCheckSurveyInnerDotSize;\n      height: @pulseCheckSurveyInnerDotSize;\n      border: 2px solid var(--color-content-neutral);\n      border-radius: 50%;\n      background: var(--color-accent-background-base);\n      box-shadow: 0 2px 8px var(--color-shadow-base);\n      content: \"\";\n      transform: translate(-50%, -50%);\n    }\n  }\n}\n\n@keyframes pulse-check-survey-dot-pulse {\n  0% {\n    transform: scale(0.75);\n    opacity: 0.55;\n  }\n\n  70% {\n    transform: scale(1.9);\n    opacity: 0;\n  }\n\n  100% {\n    transform: scale(1.9);\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
